import { FaixaCarteiraPessoaJuridica, ValorFaixaCarteiraPessoaJuridica } from './../../../../model/faixa-carteira-pessoa-juridica.model';
import { FaixaCarteiraPessoaJuridicaService } from './../faixa-carteira-pessoa-juridica.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from 'src/app/features/habilitacao/export.service';

@Component({
    selector: 'app-faixa-carteira-pessoa-juridica-pesquisa',
    templateUrl: './faixa-carteira-pessoa-juridica-pesquisa.component.html',
    standalone: false
})
export class FaixaCarteiraPessoaJuridicaPesquisaComponent implements OnInit {

  public agenteFinanceiro: string;
  public agentesFinanceirosHabilitados: AgenteFinanceiro[] = [];
  public todosAgentesFinanceiros: AgenteFinanceiro[] = [];
  public valoresFaixaCarteira: ValorFaixaCarteiraPessoaJuridica[];
  public faixasCarteira: FaixaCarteiraPessoaJuridica[];
  public numeroFaixa: string;
  public situacao: string;
  public agentesHabilitados: boolean = true;
  public pesquisado: boolean = false;
  public esconderPesquisa: boolean = true;
  public tranches: Tranche[] = [];
  public idTranche: number;
  public agentesFinanceiros;
  private opcoesPaginacao: number[];
  private atributosPaginacaoComponenteListagem: EntityPagedResult<FaixaCarteiraPessoaJuridica>;


  constructor(private activatedRoute: ActivatedRoute,
    private service: FaixaCarteiraPessoaJuridicaService,
    private trancheService: TrancheService,
    private agenteService: AgenteFinanceiroService,
    private bnLoadingService: BnLoadingService,
    private exportService: ExportService,) {
      this.opcoesPaginacao = [10, 15, 20];
      this.atributosPaginacaoComponenteListagem = {
          page: 1,
          pageSize: this.opcoesPaginacao[0],
          pages: undefined,
          count: undefined,
          list: undefined
      };            

  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscaFaixasCarteira(true)
  }

  ngOnInit(): void {
    this.agentesFinanceirosHabilitados = this.activatedRoute.snapshot.data['agentes'].sort((agente1, agente2) => agente1.nomeAgente >= agente2.nomeAgente);
    this.buscaValoresFaixaCarteira();
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches
      this.idTranche = this.tranches[this.tranches.length > 1 ? 1 : 0].id
    });
    this.agenteService.getAgentesFinanceiros().subscribe (agentes => {
      this.todosAgentesFinanceiros = agentes;
    });
    this.mostraAgentesDesabilitados();
  }

  public buscaValoresFaixaCarteira() {
    this.service.buscarValoresFaixaCarteira().subscribe((valores: ValorFaixaCarteiraPessoaJuridica[]) => {
      this.valoresFaixaCarteira = valores;
    })
  }

  mudancaPagina(novaPagina: EntityPagedResult<FaixaCarteiraPessoaJuridica>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscaFaixasCarteira(false);
}

  public buscaFaixasCarteira(reinicar: boolean) {
    this.esconderPesquisa = true;
    let dto = this.tratarFiltro();
    if (reinicar) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }
    dto.pagina = this.atributosPaginacaoComponenteListagem.page;
    dto.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    


    this.service.buscarFaixasCarteira(dto).subscribe(response => {
      this.faixasCarteira =  response ? response.resultados : undefined;
      this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
    
      // this.faixasCarteira.sort((faixa1, faixa2) => faixa1.nomeAgenteFinanceiro >= faixa2.nomeAgenteFinanceiro ? 1 : -1);
      this.pesquisado = true;
      this.esconderPesquisa = false;
    })
  }

  public limpar() {
    this.agenteFinanceiro = null;
    this.numeroFaixa = null;
    this.pesquisado = false;
  }

  public mostraAgentesDesabilitados() {
    this.agentesFinanceiros = this.agentesHabilitados? this.agentesFinanceirosHabilitados : this.todosAgentesFinanceiros;
    console.log(this.agentesFinanceiros)
  }

  private tratarFiltro() {
    let dto: any = {};
    if(this.agenteFinanceiro) {
      dto.cnpjAgenteFinanceiro = this.agenteFinanceiro;
    }
    if(this.idTranche) {
      dto.idTranche = this.idTranche;
    }
    if(this.numeroFaixa) {
      dto.numeroFaixa = this.numeroFaixa;
    }
    if(this.situacao) {
      dto.situacao = this.situacao;
    }
    return dto;
  }

  async exportar(event) {
    this.bnLoadingService.bloqueiaTela();
    try {
      const dadosPreenchidos = this.tratarFiltro();
      const resp = await this.service.buscarFaixasCarteira(dadosPreenchidos).toPromise();
      this.exportService.exportarListaFaixaPJ(resp);
    } finally {
      this.bnLoadingService.liberaTela();
    }

  }
}
